import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";
import SetPropStatePreviewBody from "./SetPropStatePreviewBody";

export default function SetPropStatePreview() {
  return (
    <PiPopupWindowPreview
      size="medium"
      body={<SetPropStatePreviewBody />}
      header={<PiPopupHeaderBar interactionType={InteractionType.SetPropState} title="Set Prop State" />}
    />
  );
}
